<template>
	<Teleport to="body">
		<div v-if="product" class="closeout-modal-overlay" @click.self="$emit('close')">
			<div class="closeout-modal">
				<button class="closeout-modal-close" @click="$emit('close')" aria-label="Close">
					&times;
				</button>
				<div class="row g-4">
					<div class="col-12 col-md-5" v-if="product.image">
						<img :src="product.image" :alt="product.name" class="img-fluid rounded" />
					</div>
					<div class="col-12 col">
						<h3 class="mb-3" v-html="product.name"></h3>
						<table class="table table-sm">
							<tbody>
								<tr>
									<th>SKU</th>
									<td>{{ product.sku }}</td>
								</tr>
								<tr>
									<th>Manufacturer</th>
									<td v-html="product.manufacturer"></td>
								</tr>
								<tr>
									<th>Category</th>
									<td>{{ product.categories.join(', ') }}</td>
								</tr>
								<tr v-if="product.shade">
									<th>Shade</th>
									<td>{{ product.shade }}</td>
								</tr>
								<tr v-if="product.serial">
									<th>Serial #</th>
									<td>{{ product.serial }}</td>
								</tr>
								<tr>
									<th>Price</th>
									<td>
										<span class="text-decoration-line-through text-muted me-2">
											${{ product.regular_price.toFixed(2) }}/{{
												product.unit || 'EA'
											}}
										</span>
										<strong class="text-success">
											${{ product.sale_price.toFixed(2) }}/{{
												product.unit || 'EA'
											}}
										</strong>
										<span
											v-if="product.discount_pct"
											class="badge bg-danger ms-2"
										>
											-{{ product.discount_pct }}%
										</span>
									</td>
								</tr>
								<tr>
									<th>Qty Available</th>
									<td>
										{{
											product.stock_quantity !== null
												? product.stock_quantity.toLocaleString()
												: '—'
										}}
										{{ product.unit || '' }}
									</td>
								</tr>
								<tr v-for="(value, key) in extraAttributes" :key="key">
									<th>{{ key }}</th>
									<td>{{ value }}</td>
								</tr>
							</tbody>
						</table>
						<div
							v-if="product.description"
							class="mb-3"
							v-html="product.description"
						></div>
						<div class="d-flex align-items-center gap-2 mt-3">
							<input
								v-model.number="product._qty"
								type="number"
								class="form-control closeout-qty-input"
								min="0"
								style="max-width: 30%"
							/>
							<span class="text-muted me-auto">{{ product.unit || 'EA' }}</span>
							<span v-if="product._added" class="text-success fw-bold">
								&#10004; Added
							</span>
							<button
								v-else
								class="btn btn-primary"
								:disabled="product._adding || !product._qty"
								@click="$emit('add-to-cart', product)"
							>
								<span
									v-if="product._adding"
									class="spinner-border spinner-border-sm"
								></span>
								<span v-else>ADD TO ORDER</span>
							</button>
						</div>
					</div>
				</div>
			</div>
		</div>
	</Teleport>
</template>

<script>
import { computed } from 'vue';

export default {
	name: 'CloseoutModal',
	props: {
		product: { type: Object, default: null },
	},
	emits: ['close', 'add-to-cart'],
	setup(props) {
		const extraAttributes = computed(() => {
			if (!props.product) return {};
			const skip = [
				'manufacturer',
				'Manufacturer',
				'shade',
				'Shade',
				'serial',
				'Serial',
				'Serial #',
				'unit',
				'Unit',
			];
			const result = {};
			for (const [key, value] of Object.entries(props.product.attributes || {})) {
				if (!skip.includes(key) && value) {
					result[key] = value;
				}
			}
			return result;
		});

		return { extraAttributes };
	},
};
</script>
